import { packageTerms } from "./linkBuildingPackages";

/**
 * Single source of truth for the homepage FAQ. Consumed by FAQSection.tsx and
 * by scripts/generate-route-html.mjs so the visible answers and the FAQPage
 * JSON-LD can never drift apart.
 */
export const homeFaqs = [
  {
    question: "What are quality backlinks?",
    answer: "Quality backlinks are links from relevant websites with genuine content and an audience. We check niche relevance, domain metrics and organic traffic before placing a guest post. A high DR score alone is not enough to judge a site.",
  },
  {
    question: "How much do Linkzy’s link building packages cost?",
    answer: `Starter costs $${packageTerms[0].price.toLocaleString("en-US")} USD for ${packageTerms[0].links} guest posts. Business costs $${packageTerms[1].price.toLocaleString("en-US")} USD for ${packageTerms[1].links} guest posts. Both include content and a custom report. Custom packages are quoted for your requirements.`,
  },
  {
    question: "Do I need to write the guest post content?",
    answer: "No. Content is included in the Starter and Business guest post packages. Share your website, target pages and niche so we can discuss the right placement scope for your campaign.",
  },
  {
    question: "How are the host websites checked?",
    answer: `Standard packages specify DR ${packageTerms[0].minimumDR}+. Starter sites have at least ${packageTerms[0].monthlyTraffic.toLocaleString("en-US")} monthly organic visits and Business sites at least ${packageTerms[1].monthlyTraffic.toLocaleString("en-US")}, verified via Ahrefs. These are host-site estimates, not a promise of visits to your website. We also assess niche relevance.`,
  },
  {
    question: "How long does delivery take?",
    answer: `Average delivery is ${packageTerms[0].deliveryWeeks[0]} to ${packageTerms[0].deliveryWeeks[1]} weeks for Starter and ${packageTerms[1].deliveryWeeks[0]} to ${packageTerms[1].deliveryWeeks[1]} weeks for Business. Delivery means guest post placements, not guaranteed ranking improvements. Search results depend on your content, competition and wider SEO work.`,
  },
  {
    question: "Do you guarantee rankings or AI Overview appearances?",
    answer: "No. No link building package can guarantee Google rankings, traffic or inclusion in AI answers. We focus on relevant placements, clear quality checks and reporting rather than promises about outcomes we cannot control.",
  },
  {
    question: "Do you use private blog networks or automated placements?",
    answer: "No. We use real websites with verified organic traffic and manually place guest posts. We do not use PBNs, link farms or automated link placement.",
  },
  {
    question: "How do I request sample sites or a quote?",
    answer: "Send your website and email using the sample-site enquiry above, or tell us about your goals on the contact page. We review your website and share relevant sample sites and a proposal. Requesting samples does not require payment.",
  },
];
